import { toast } from '@/view/components/ui/use-toast'
import { LiveFormValues } from '@/view/pages/Conteudos/hooks/useLiveForm'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { LiveService } from '../services/liveService'

export const useLiveMutations = () => {
  const queryClient = useQueryClient()

  const deleteLive = useMutation({
    mutationFn: LiveService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['lives'],
        exact: false,
      })
      toast({
        title: 'Live deletada com sucesso',
        variant: 'default',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar live',
        variant: 'destructive',
      })
    },
  })

  const createLive = useMutation({
    mutationFn: LiveService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['lives'],
        exact: false,
      })
      toast({
        title: 'Live criada com sucesso',
        variant: 'default',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao criar live',
        variant: 'destructive',
      })
    },
  })

  const updateLive = useMutation({
    mutationFn: ({ id, data }: { id: string; data: LiveFormValues }) =>
      LiveService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['lives'],
        exact: false,
      })
      toast({
        title: 'Live atualizada com sucesso',
        variant: 'default',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao atualizar live',
        variant: 'destructive',
      })
    },
  })

  return { deleteLive, createLive, updateLive }
}
